'use es6';

import { List } from 'immutable';
import { addCondition, findConditionKeyPath, getConditionKey, makeLogicGroup, removeKeyPath } from './LogicGroup';
import reduce from 'transmute/reduce';
const Constraint = makeLogicGroup('Constraint');
addCondition.implement(Constraint, (condition, group, filterFamily) => {
  const conditionKey = getConditionKey(condition, group, filterFamily);
  return group.setIn(['conditions', conditionKey], condition);
});
Constraint.applyToGroup = constraint => group => {
  return constraint && group ? addCondition(constraint.conditions.first(), group) : group;
};
Constraint.removeFromGroup = constraint => group => {
  if (!(constraint && group)) return group;
  return reduce(group, (nextGroup, condition) => {
    const path = findConditionKeyPath(condition, group);
    return removeKeyPath(List.of(path), nextGroup);
  }, constraint.conditions);
};
export default Constraint;